import React from 'react';
// import BookingForm from '../booking-form';
import { StaticQuery, graphql } from 'gatsby';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import PricingPageStyle from './pricing-page.module.scss';

const HeroContent = () => (
  <StaticQuery
    query={graphql`
      query PricingHero {
        contentfulPricingPlansAssemblyPage {
          hero {
            headline {
              headline
            }
            paragraph {
              json
            }
          }
        }
      }
    `}
    render={(data) => (
      <div className={PricingPageStyle.heroContentDiv}>
        <h1 className={PricingPageStyle.heroTitle}>
          {data.contentfulPricingPlansAssemblyPage.hero.headline.headline}
        </h1>
        <div className={PricingPageStyle.heroDescription}>
          {documentToReactComponents(
            data.contentfulPricingPlansAssemblyPage.hero.paragraph.json
          )}
        </div>

        <a
          href='https://app.firststringdigital.com/starter-monthly'
          className='hero-btn'
        >
          Start My Free Trial
        </a>
      </div>
    )}
  />
);

export default HeroContent;
